<template>
  <div class="page-wrapper">
    <alert-window ref="alertWindow"></alert-window>
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories/districts" style="color: black">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                Области
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <div class="title">
                        {{ isNew ? 'Новый район' : 'Редактировать район' }}
                      </div>
                    </div>
                    <div class="region-map">
                      <div id="map" style="width: 100%; height: 1000px"></div>
                    </div>
                    <div class="head-panel visibility">
                      <div v-show="isAdmin" @click="clearDistrict" class="clear-region">
                        <i class="fa fa-paint-brush"></i>Очистить район
                      </div>
                    </div>
                    <div class="directory-box region-info-form">
                      <div class="main-content">
                        <div class="form">
                          <div class="fieldset">
                            <label class="fieldset-title">Наименование района</label>
                            <fieldset><input type="text" v-model="name"></fieldset>
                          </div>
                          <div v-show="isAdmin" class="buttons">
                            <button type="button" class="save-button" @click="save">Сохранить</button>
                            <span class="delete" v-show="!isNew" @click="remove">
                              <i class="fa fa-trash-o"></i>Удалить район</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MenuDispatcher from '@/components/MenuDispatcher.vue'
  import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
  import AlertWindow from '@/components/AlertWindow.vue'
  import api from '@/api'

  export default {
    name: 'District',
    components: { AlertWindow, HeaderDispatcher, MenuDispatcher },

    data () {
      return {
        district: {},
        newDistrict: {},
        districts: {},
        districtPolygons: {},
        polygonsList: [],
        polygonsListForMap: [],
        isNew: false,
        districtMap: {},
        districtPolygon: {},
        districtEditCompleteBtn: {},
        isAdmin: this.$store.getters.roleCode === 'ROLE_SUPER_ADMIN'
      }
    },

    computed: {
      name: {
        get () {
          return !this.isNew ? this.district.name : this.newDistrict.name
        },

        set (name) {
          !this.isNew ? this.district.name = name : this.newDistrict.name = name
        }
      }
    },

    created () {
      this.initDistrictMap().then(
          map => {
            let id = this.$route.params.id
            if (id == 'new') {
              this.isNew = true
              this.newDistrict = {
                name: null,
                points: []
              }
              this.addDistrict(map)
            } else {
              api
                  .getDistrictById(id)
                  .then(district => {
                    if (district) {
                      this.district = district
                      this.editDistrict(id)
                    }
                  })
            }
          })
    },

    mounted () {
      let body = document.getElementsByTagName('body')[0]
      body.classList.add('cabinet-page')
    },

    destroyed () {
      let body = document.getElementsByTagName('body')[0]
      body.classList.remove('cabinet-page')
    },

    methods: {
      save () {
        let regPoints = this.districtPolygon.geometry.getCoordinates()[0].reduce((l, x) => {
          l.push(
              {
                lat: x[0],
                lng: x[1]
              }
          )
          return l
        }, [])

        if (this.name) {
          if (regPoints.length > 3 &&
              !this.hasIntersections(this.districtPolygon.geometry.getCoordinates()[0])) {
            if (this.isNew) {
              this.newDistrict.points = regPoints
              api
                  .createDistrict(this.newDistrict)
                  .then(() => {
                    this.$router.push('/directories/districts')
                    alert('Сохранено')
                  })
                  .catch(err => alert(err))
            } else {
              this.district.points = regPoints
              api
                  .updateDistrict(this.$route.params.id, this.district)
                  .then(() => {
                    this.$router.push('/directories/districts')
                    alert('Сохранено')
                  })
                  .catch(err => alert(err))
            }
          } else {
            this.$refs.alertWindow.show('Ошибка', 'Сформируйте область', true)
          }
        } else {
          this.$refs.alertWindow.show('Ошибка', 'Введите название', true)
        }
      },

      remove () {
        api
            .deleteDistrictById(this.district.id)
            .then(() => {
              this.$router.push('/directories/districts')
              alert('Удалено')
            })
            .catch(err => alert(err))
      },

      initDistrictMap () {
        return new Promise((resolve, reject) => {
          ymaps.ready(() => {
            this.districtMap = new ymaps.Map('map', {
              center: [55.796289, 49.108795],
              zoom: 12,
              controls: []
            }, {
              searchControlProvider: 'yandex#search',
              suppressMapOpenBlock: true
            })
            this.districtEditCompleteBtn = new ymaps.control.Button({
              data: {
                content: 'Завершить формирование области'
              },
              options: {
                maxWidth: 300,
                visible: false
              }
            })
            this.districtEditCompleteBtn.events.add('click', () => {
              this.districtPolygon.editor.stopDrawing()
              this.districtPolygon.editor.stopEditing()
            })
            this.districtMap.controls.add(this.districtEditCompleteBtn)

            // словарь многоугольников для манипулирания ими
            this.polygonsList = []

            // список многоугольников для вывода на карту
            this.polygonsListForMap = new ymaps.GeoObjectCollection()

            api
                .getDistricts()
                .then(districts => {
                  if (districts) {
                    this.districts = districts
                    for (let i = 0; i < districts.length; i++) {
                      // создаем многоугольник
                      let pol = new ymaps.Polygon(
                          // формируем список координат района в виде [ [lat, lng], .. , [lat, lng] ]
                          [districts[i].points.reduce((l, x) => {
                            l.push([x.lat, x.lng])
                            return l
                          }, [])],

                          // по умолчанию многоугольник будет с такими характеристиками
                          {}, {
                            fillColor: '#276391',
                            opacity: 0.5,
                            strokeWidth: 5,
                            editorMenuManager: (items) => {
                              return items.slice(0, -1)
                            }
                          }
                      )

                      // ключ - id района, значение - многоугольник
                      this.polygonsList[districts[i].id] = pol

                      // добавляем в список многоугольников карты
                      this.polygonsListForMap.add(pol)
                    }
                    // добавляем на карту список полигонов
                    this.districtMap.geoObjects.add(this.polygonsListForMap)
                  }
                })

            resolve(this.districtMap)
          })
        })
      },

      addDistrict (map) {
        ymaps.ready(() => {
          // Создаем многоугольник без вершин.
          this.districtPolygon = new ymaps.Polygon([], {}, {
            name: 'newDistrict',
            // Курсор в режиме добавления новых вершин.
            editorDrawingCursor: 'crosshair',
            // editorMaxPoints: 6,
            fillColor: '#fc895d',
            strokeColor: '#00FF00',
            opacity: 0.6,
            strokeWidth: 5,
            editorMenuManager: (items) => {
              return items.slice(0, -1)
            }
          })
          // Добавляем многоугольник на карту.
          map.geoObjects.add(this.districtPolygon)

          this.startDrawingnewDistrict()
        })
      },

      editDistrict (id) {
        // пауза для того чтобы успеть загрузить текущую область
        window.setTimeout(() => {
          this.districtPolygon = this.polygonsList[id]
          this.districtPolygon.options.set('fillColor', '#fc895d')
          this.districtPolygon.options.set('strokeColor', '#f94400')
          this.districtEditCompleteBtn.options.set('visible', true)
          this.districtPolygon.editor.startEditing()
        }, 1000)
      },

      clearDistrict () {
        this.districtPolygon.geometry.setCoordinates([])
        this.districtEditCompleteBtn.deselect()
        this.startDrawingnewDistrict()
        document.getElementsByClassName('directorys-page')[0].scrollTop = 0
      },

      startDrawingnewDistrict () {
        this.districtEditCompleteBtn.options.set('visible', true)
        this.districtPolygon.options.set('editorDrawingCursor', 'crosshair')
        // Включаем режим редактирования с возможностью добавления новых вершин.
        this.districtPolygon.editor.startDrawing()
      },

      hasIntersections (districtPoints) {
        let has = false
        let polList = this.polygonsListForMap.toArray().filter((x) => {
          return x !== this.districtPolygon
        })
        polList.forEach(polygon => {
          polygon.geometry.getCoordinates()[0].forEach(point => {
            if (this.districtPolygon.geometry.contains(point)) {
              has = true
              return true
            }
          })
          districtPoints.forEach(point => {
            if (polygon.geometry.contains(point)) {
              has = true
              return true
            }
          })
        })
        if (has) alert('Имеются пересечения!')
        return has
      }
    }
  }
</script>
